module.exports = __webpack_public_path__ + "img/displacement.8b9e9809.jpg";